module.exports = __webpack_public_path__ + "images/ExternalPromo/advertsquare.png?fd2cf";